import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byteSize',
  standalone: true
})
export class ByteSizePipe implements PipeTransform {
  transform(value: any, decimals: number = 2): any {
    if (value <= 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(value) / Math.log(k));

    return parseFloat((value / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
